<script>
  let { skeletonLength = Math.floor(Math.random() * 3) } = $props();
</script>

<div class="relative w-full shadow-y-sm rounded-sm bg-white mb-4">
  <div class="w-full px-3 py-2 flex justify-between align-middle">
    <div
      class="h-4 my-1 skeleton-gradient animated-skeleton"
      class:w-22={skeletonLength === 0}
      class:w-28={skeletonLength === 1}
      class:w-36={skeletonLength === 2}
    ></div>
    <span>
      <div class="h-4 my-1 skeleton-gradient animated-skeleton w-18"></div>
    </span>
  </div>
</div>
